
/// <amd-module name="Release/Commands/RenameFolderService" />
import * as React from "react";

import { Services, VssService, IVssService } from "VSS/Platform/Context";
import { IMenuItem } from "VSSUI/Menu";
import { IVssLayoutManager, IWrappedComponentProperties, WrappedComponent } from "VSS/Platform/Layout";

import { hasRmPermissions, ReleaseManagementSecurityPermissions } from "Release/Helpers/Permission";
import { IReleaseDefinitionPivotCommandContext } from "Release/Client/ExtensionContracts/IMenuCommandContracts";
import { publishClickEvent } from "Release/Helpers/Telemetry";
import { IFolderDetailsDialogProps } from "./DialogTypes";
import * as Resources from "Release/Commands/Resources";


export const renameFolderAction: (context: IReleaseDefinitionPivotCommandContext, renameFolderCallback?: (path: string) => any, parentButtonId?: string) => IMenuItem | undefined = (context: IReleaseDefinitionPivotCommandContext, renameFolderCallback?: (path: string) => any, parentButtonId?: string) => {
    if (context.folderPath !== "\\" && hasRmPermissions(context.pageContext, context.folderPath, context.pipelineId, ReleaseManagementSecurityPermissions.EditReleaseDefinition)) {
        return {
            id: "rename-folder-command",
            text: Resources.RenameFolderCommand,
            important: false,
            iconProps: { iconName: "Rename" },
            onActivate: () => {
                context.pageContext.getService<IRenameFolderService>("IRenameFolderService").renameFolder(context, renameFolderCallback, parentButtonId);
            }
        };
    }
};

export interface IRenameFolderService extends IVssService {
    renameFolder(context: IReleaseDefinitionPivotCommandContext, renameFolderCallback?: (updatedFolderPath: string) => void, parentButtonId?: string): void;
}

class RenameFolderService extends VssService implements IRenameFolderService {
    public renameFolder(context: IReleaseDefinitionPivotCommandContext, renameFolderCallback?: (updatedFolderPath: string) => void, parentButtonId?: string): void {
        publishClickEvent(this.pageContext, renameFolderFeature, context.telemetrySource);
        const layoutManager = context.pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
        const lastIndexOfSeperator = context.folderPath.lastIndexOf("\\");
        const parentPath = context.folderPath.substring(0, lastIndexOfSeperator) || "\\";
        const folderName = context.folderPath.substring(lastIndexOfSeperator + 1);

        layoutManager.renderCallout((onDismiss) => {
            const props: IFolderDetailsDialogProps & IWrappedComponentProperties = {
                wrappedType: "release-folder-dialog",
                dependencies: ["ms.vss-releaseManagement-web.release-command-dialogs"],
                title: Resources.RenameFolderDialogTitle,
                parentPath: parentPath,
                parentButtonId: parentButtonId,
                name: folderName,
                onClose: onDismiss,
                onFolderUpdated: renameFolderCallback
            };

            return React.createElement(WrappedComponent, props);
        });
    }
}

const renameFolderFeature: string = "Command_RenameFolder";

Services.add("IRenameFolderService", { serviceFactory: RenameFolderService });
